import tiposDocumentosJson from 'utils/tiposDocumentos.json';
import { FP } from 'components/financepro';

export const PROGRAMA_ENTRADAS_DIARIO = 'entradasdiario';

const tiposContables =
  tiposDocumentosJson.find((e) => Array.isArray(e?.tiposdocumentocontable))?.tiposdocumentocontable ||
  [];

export const TIPO_DOCUMENTO_AJUSTE_ENTRADAS =
  tiposContables.find((n) => String(n).toLowerCase().replace(/\s+/g, '') === 'ajusteentradas') ||
  'Ajuste Entradas';

export const fmtMoney = (v) =>
  (parseFloat(v) || 0).toLocaleString('es-DO', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export const fechaLocalHoy = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
};

export const primerDiaAno = () => {
  const d = new Date();
  return `${d.getFullYear()}-01-01`;
};

export const formatearFecha = (fecha) => {
  if (!fecha) return '—';
  const s = String(fecha).slice(0, 10);
  if (!/^\d{4}-\d{2}-\d{2}$/.test(s)) return fecha;
  const [y, m, d] = s.split('-');
  return `${d}-${m}-${y}`;
};

export const labelCuentaCatalogo = (c) => {
  if (!c) return '';
  const cod = String(c.cuenta ?? '').trim();
  const nom = String(c.nombre ?? '').trim();
  return cod && nom ? `${cod} — ${nom}` : cod || nom;
};

export const labelCentroCosto = (c) => {
  if (!c) return '';
  const id = c.id != null ? String(c.id).trim() : '';
  const d = String(c.descrip ?? '').trim();
  return id && d ? `${id} — ${d}` : id || d;
};

export const cuentasPosteablesDeCatalogo = (cuentasCatalogo) => {
  const maestros = new Set(
    (cuentasCatalogo || []).map((c) => String(c.maestra || '').trim()).filter(Boolean)
  );
  return (cuentasCatalogo || []).filter((c) => {
    const cod = String(c.cuenta || '').trim();
    if (!cod) return false;
    if (String(c.clase || '').trim().toUpperCase() === 'M') return false;
    if (maestros.has(cod)) return false;
    return true;
  });
};

export const wanomesDesdeAnomesContabilidad = (anomes) => {
  const s = String(anomes ?? '').trim();
  const digits = s.startsWith('M') || s.startsWith('m') ? s.slice(1) : s;
  if (!/^\d{6}$/.test(digits)) return null;
  return digits;
};

const zanomesDesdeFechaStr = (fechaStr) => {
  const t = (fechaStr || '').trim();
  if (!/^\d{4}-\d{2}-\d{2}$/.test(t)) return null;
  const [y, m] = t.split('-').map((x) => parseInt(x, 10));
  if (!y || !m || m < 1 || m > 12) return null;
  return `${y}${String(m).padStart(2, '0')}`;
};

export const validarMesContableAbierto = (fechaStr, wanomesAbierto) => {
  if (!wanomesAbierto) return { ok: true };
  const z = zanomesDesdeFechaStr(fechaStr);
  if (!z) return { ok: false, message: 'Indique una fecha de asiento válida.' };
  if (parseInt(z, 10) < parseInt(wanomesAbierto, 10)) {
    return {
      ok: false,
      message:
        'La fecha se encuentra en un mes cerrado (anterior al período contable abierto en varinicial).',
    };
  }
  return { ok: true };
};

export const ladoDesdeOrigenCuenta = (origen) => {
  const o = String(origen || '').trim().toLowerCase();
  if (o.startsWith('cred')) return 'Credito';
  return 'Debito';
};

export const cardShellSx = {
  borderRadius: 2.5,
  bgcolor: FP.color.cardBg,
  boxShadow: FP.shadow.soft,
  border: `1px solid ${FP.color.border}`,
  overflow: 'hidden',
};

export const filterHeaderSx = {
  px: { xs: 2, md: 3 },
  py: 1.6,
  borderBottom: `1px solid ${FP.color.border}`,
  bgcolor: '#FAFBFE',
  display: 'flex',
  alignItems: 'center',
  gap: 1.2,
};

export const cellHeadSx = {
  fontWeight: 700,
  fontSize: '0.75rem',
  color: FP.color.textSecondary,
  letterSpacing: '0.04em',
  textTransform: 'uppercase',
  display: 'block',
  mb: 0.5,
  whiteSpace: 'nowrap',
};

export const btnPrimarySx = {
  height: 46,
  bgcolor: FP.color.navy,
  color: '#FFFFFF',
  borderRadius: 1.4,
  textTransform: 'none',
  fontWeight: 700,
  boxShadow: 'none',
  '&:hover': { bgcolor: FP.color.navyDeep, boxShadow: 'none' },
  '&.Mui-disabled': { bgcolor: FP.color.border, color: FP.color.textMuted },
};

export const btnOutlinedSx = {
  height: 46,
  borderColor: FP.color.border,
  color: FP.color.textPrimary,
  bgcolor: '#FFFFFF',
  borderRadius: 1.6,
  textTransform: 'none',
  fontWeight: 700,
  '&:hover': { bgcolor: FP.color.surfaceAlt, borderColor: FP.color.borderStrong },
};
